import moment from 'moment';

import { request, requestConfig } from 'utils/request.js';

import {
    ARCHIVE_ASSIGNMENT, ARCHIVE_ASSIGNMENT_SUCCESS, ARCHIVE_ASSIGNMENT_FAILURE,
    FETCH_ASSIGNMENT, FETCH_ASSIGNMENT_SUCCESS, FETCH_ASSIGNMENT_FAILURE,
    FETCH_ASSIGNMENTS, FETCH_ASSIGNMENTS_SUCCESS, FETCH_ASSIGNMENTS_FAILURE,
    FETCH_USERS_IN_GROUPS_FOR_ASSIGNMENTS, FETCH_USERS_IN_GROUPS_FOR_ASSIGNMENTS_SUCCESS, FETCH_USERS_IN_GROUPS_FOR_ASSIGNMENTS_FAILURE,
    REMOVE_ASSIGNMENT, REMOVE_ASSIGNMENT_SUCCESS, REMOVE_ASSIGNMENT_FAILURE,
    SAVE_ASSIGNMENT, SAVE_ASSIGNMENT_SUCCESS, SAVE_ASSIGNMENT_FAILURE,
    CLEAR_ASSIGNMENT, EMPTY_ASSIGNMENTS, SET_ASSIGNMENT, UPDATE_ASSIGNMENTS, UPDATE_SEARCH_TERM
} from './constants';

import { PATHS } from 'utils/paths';
import { ASSIGNMENT_STATES, ASSIGNMENT_STATUSES } from 'containers/AssignmentsPage/constants'

const archiveAssignment = () => ({
    type: ARCHIVE_ASSIGNMENT
});

const archiveAssignmentSuccess = (data) => ({
    type: ARCHIVE_ASSIGNMENT_SUCCESS,
    data
});

const archiveAssignmentFailure = (error) => ({
    type: ARCHIVE_ASSIGNMENT_FAILURE,
    error
});

const fetchAssignment = () => ({
    type: FETCH_ASSIGNMENT
});

const fetchAssignmentSuccess = (data) => ({
    type: FETCH_ASSIGNMENT_SUCCESS,
    data
});

const fetchAssignmentFailure = (error) => ({
    type: FETCH_ASSIGNMENT_FAILURE,
    error
});

const fetchAssignments = () => ({
    type: FETCH_ASSIGNMENTS
});

const fetchAssignmentsSuccess = (data) => ({
    type: FETCH_ASSIGNMENTS_SUCCESS,
    data
});

const fetchAssignmentsFailure = (error) => ({
    type: FETCH_ASSIGNMENTS_FAILURE,
    error
});

const fetchUsersInGroupsForAssignments = () => ({
    type: FETCH_USERS_IN_GROUPS_FOR_ASSIGNMENTS
});

const fetchUsersInGroupsForAssignmentsSuccess = () => ({
    type: FETCH_USERS_IN_GROUPS_FOR_ASSIGNMENTS_SUCCESS
});

const fetchUsersInGroupsForAssignmentsFailure = (error) => ({
    type: FETCH_USERS_IN_GROUPS_FOR_ASSIGNMENTS_FAILURE,
    error
});

const removeAssignment = () => ({
    type: REMOVE_ASSIGNMENT
});

const removeAssignmentSuccess = () => ({
    type: REMOVE_ASSIGNMENT_SUCCESS
});

const removeAssignmentFailure = () => ({
    type: REMOVE_ASSIGNMENT_FAILURE
});

const saveAssignment = () => ({
    type: SAVE_ASSIGNMENT
});

const saveAssignmentSuccess = (data) => ({
    type: SAVE_ASSIGNMENT_SUCCESS,
    data
});

const saveAssignmentFailure = (error) => ({
    type: SAVE_ASSIGNMENT_FAILURE,
    error
});

export const clearAssignment = () => ({
    type: CLEAR_ASSIGNMENT
});

export const emptyAssignments = () => ({
    type: EMPTY_ASSIGNMENTS
});

export const setAssignment = (data) => ({
    type: SET_ASSIGNMENT,
    data
});

export const updateAssignments = (data) => ({
    type: UPDATE_ASSIGNMENTS,
    data
});

export const updateSearchTerm = (data) => ({
    type: UPDATE_SEARCH_TERM,
    data
});


/**
 *  ASYNC ACTIONS
 */

export const archiveUnarchiveAssignment = () => (dispatch, getState) => {
    dispatch(archiveAssignment());

    let assignment = JSON.parse(JSON.stringify(getState().assignments.assignment));

    if(assignment.archived === true) {
        assignment.archived = false;
    } else {
        assignment.archived = true;
    }

    return request(PATHS.assignments.putAssignment(assignment.id), requestConfig('PUT', assignment))
        .then(() => {
            let assignments = getState().assignments.allAssignments;
            for(var i = 0, l = assignments.length; i < l; i++) {
                if(assignments[i].id === assignment.id) {
                    assignments.splice(i, 1);
                    dispatch(archiveAssignmentSuccess(assignments));
                    break;
                }
            }
        })
        .catch((error) => {
            dispatch(archiveAssignmentFailure(error));
        });
};

export const getAssignment = (assignment) => (dispatch) => {
    dispatch(fetchAssignment());

    return request(PATHS.assignments.getAssignment(assignment.id), requestConfig('GET'))
        .then((fullAssignment) => {
            //console.log('ass', fullAssignment);
            dispatch(fetchAssignmentSuccess(fullAssignment));
            return fullAssignment;
        })
        .catch((error) => {
            console.log('error getting full assignment', error);
            dispatch(fetchAssignmentFailure(error));
        });
};

export const getAssignments = (callback) => (dispatch, getState) => {
    dispatch(fetchAssignments());

    let assignmentsState = getState().assignments;
    let path = '';
    let pageNumber = assignmentsState.pageNumber + 1;

    if(assignmentsState.searchTerm !== '') {
        path = PATHS.assignments.getAssignments.search(assignmentsState.searchTerm, pageNumber, assignmentsState.pageSize);
    } else if(assignmentsState.filterBy !== '') {
        let userId = getState().auth.user.id;
        path = PATHS.assignments.getAssignments.filtered(assignmentsState.filterBy, assignmentsState.sortBy, assignmentsState.sortDirection, pageNumber, assignmentsState.pageSize, userId);
    } else {
        path = PATHS.assignments.getAssignments.sorted(assignmentsState.sortBy, assignmentsState.sortDirection, pageNumber, assignmentsState.pageSize);
    }

    request(path, requestConfig('GET'))
        .then((data) => {
            dispatch(fetchAssignmentsSuccess(data));
            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            console.log(error);
            dispatch(fetchAssignmentsFailure(error));
        });
};

export const cloneAssignment = (assignment, callback) => (dispatch, getState) => {
    dispatch(saveAssignment());

    delete assignment.id;
    delete assignment.contentUserStatuses;
    delete assignment.userStatuses;
    delete assignment.dueDate;
    assignment.archived = false;
    assignment.startDate = parseInt(moment().format('x'), 10);
    assignment.modified = new Date().getTime();
    assignment.state = ASSIGNMENT_STATES.UNPUBLISHED;
    assignment.status = ASSIGNMENT_STATUSES.NO_PROGRESS;

    request(PATHS.assignments.postAssignment(), requestConfig('POST', assignment))
        .then((newAssignment) => {
            //If it's a new user, then get all users again
            let assignments = getState().assignments;
            assignments.pageNumber = 0;
            assignments.hasMore = true;
            assignments.allAssignments = [];
            dispatch(updateAssignments(assignments));
            dispatch(getAssignments());

            if(callback) {
                callback();
            }

            dispatch(saveAssignmentSuccess({}));
        })
        .catch((error) => {
            dispatch(saveAssignmentFailure(error));
        });
};

export const deleteAssignment = (callback) => (dispatch, getState) => {
    dispatch(removeAssignment());
    let assignment = getState().assignments.assignment;
    request(PATHS.assignments.putAssignment(assignment.id), requestConfig('DELETE'))
        .then(() => {
            // Loop through all existing users to see if this user exists. If so, remove it
            let assignments = getState().assignments.allAssignments;
            for(var i = 0, l = assignments.length; i < l; i++) {
                if(assignments[i].id === assignment.id) {
                    assignments.splice(i, 1);
                    break;
                }

            }
            dispatch(removeAssignmentSuccess());
            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            dispatch(removeAssignmentFailure(error));
        })
};

export const getUsersAndSetAssignment = (assignment) => (dispatch) => {
    assignment.contentUserStatuses = [];
    //dispatch(setAssignment(assignment));

    dispatch(getAssignment(assignment))
        .then((fullAssignment) => {
            dispatch(fetchUsersInGroupsForAssignments());
            let completedGroupsCount = 0;
            fullAssignment.groups.forEach((group) => {
                let completedUsersCount = 0;
                let users = [];
                group.userIds.forEach((id) => {
                    request(PATHS.users.getUser.byID(id), requestConfig('GET'))
                        .then((user) => {
                            completedUsersCount++;
                            users.push(user);
                            if(completedUsersCount === group.userIds.length) {
                                group.users = users;
                                completedGroupsCount++;
                                if(completedGroupsCount === fullAssignment.groups.length) {
                                    dispatch(fetchUsersInGroupsForAssignmentsSuccess());
                                    dispatch(setAssignment(fullAssignment));
                                }
                            }
                        })
                        .catch((error) => {
                            console.log('error getting users in groups', error);
                            dispatch(fetchUsersInGroupsForAssignmentsFailure(error));
                        });
                });
            });
        });
};

export const postPutAssignment = (callback) => (dispatch, getState) => {
    dispatch(saveAssignment());

    let assignment = getState().assignments.assignment;

    let method = 'POST';
    let path = PATHS.assignments.postAssignment();

    if(assignment.id != null) {
        method = 'PUT';
        path = PATHS.assignments.putAssignment(assignment.id);
    }

    if(assignment.startDate === 0 && assignment.state === ASSIGNMENT_STATES.UNPUBLISHED) {
        delete assignment.startDate;
    }

    if(assignment.dueDate === 0 && assignment.state === ASSIGNMENT_STATES.UNPUBLISHED) {
        delete assignment.dueDate;
    }

    request(path, requestConfig(method, assignment))
        .then((newAssignment) => {

            dispatch(saveAssignmentSuccess(newAssignment));

            if(method === 'PUT' && getState().assignments.sortBy !== 'modified') { // I'm intentionally excluding modified here, because the user will go at the top, if they are not already
                // Loop through all existing users to see if this user exists. If so, replace it in the array
                let assignments = getState().assignments.allAssignments;
                for(var i = 0, l = assignments.length; i < l; i++) {
                    if(assignments[i].id === newAssignment.id) {
                        assignments[i] = newAssignment;
                        break;
                    }
                }
            } else {
                //If it's a new user, then get all users again
                let assignments = getState().assignments;
                assignments.pageNumber = 0;
                assignments.hasMore = true;
                assignments.allAssignments = [];
                dispatch(updateAssignments(assignments));
                dispatch(getAssignments());
            }

            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            dispatch(saveAssignmentFailure(error));
        });
};



// WEBPACK FOOTER //
// ./src/containers/AssignmentsPage/store/actions.js